"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledHelpCircle = exports.StyledGridItem = exports.StyledErrorCircle = exports.ErrorMesssageText = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const StyledHelpCircle = exports.StyledHelpCircle = (0, _mui.styled)(_icons.HelpCircle)(({
  theme
}) => ({
  fontSize: '22px',
  color: theme.palette.grey[300]
}));
const StyledErrorCircle = exports.StyledErrorCircle = (0, _mui.styled)(_icons.ErrorCircleFilled)(() => ({
  fontSize: '25px'
}));
const ErrorMesssageText = exports.ErrorMesssageText = (0, _mui.styled)('div')(() => ({
  fontStyle: 'italic'
}));
const StyledGridItem = exports.StyledGridItem = (0, _mui.styled)(_mui.Grid)(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column'
}));
